/**
 *   Type of publication.  Indicates differences in publication structure.
 */
enum PublicationTypes {
    NEC = "NEC",
    NFC = "NFC",
}

export default PublicationTypes;
